import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { WrappedApp, WrappedUIComponent, ResponsivePageComponent } from './wrapper-components';
const renderApp = (context) => {
    const container = document.getElementById(context.root);
    if (container) {
        createRoot(container).render(_jsx(WrappedApp, { context: context }));
    }
};
window.renderApp = renderApp;
window.renderDashboard = renderApp;
// The auth surface loads as its own chunk so the login page never parses the
// dashboard tree. The chunk fetch starts as soon as renderAuth is called.
const LazyAuthApp = React.lazy(() => import(/* webpackChunkName: "auth" */ './wrapper-auth'));
window.renderAuth = (config) => {
    const container = document.getElementById('root');
    if (!container)
        return;
    createRoot(container).render(_jsx(Suspense, { fallback: null, children: _jsx(LazyAuthApp, { config: config }) }));
};
// Developer-only surfaces: loaded on demand, dead weight in production
window.renderDevDashboard = (context) => {
    const container = document.getElementById(context.root);
    if (!container)
        return;
    import(/* webpackChunkName: "dev" */ './wrapper-dev').then((m) => {
        createRoot(container).render(_jsx(m.WrappedUXPDevDashboard, { context: context }));
    });
};
window.renderDevUI = (context) => {
    const container = document.getElementById(context.root);
    if (!container)
        return;
    import(/* webpackChunkName: "dev" */ './wrapper-dev').then((m) => {
        createRoot(container).render(_jsx(m.WrappedDevUIComponent, { context: context }));
    });
};
window.renderUI = (context, id, additionalProps) => {
    const container = document.getElementById(context.root);
    if (container) {
        createRoot(container).render(_jsx(WrappedUIComponent, { context: context, id: id, additionalProps: additionalProps }));
    }
};
window.renderPage = (context, widget, embeded) => {
    const container = document.getElementById(context.root);
    if (container) {
        createRoot(container).render(_jsx(ResponsivePageComponent, { context: context, widget: widget, embedded: embeded }));
    }
};
